export default function Response({ success, message, data={} }) {
  return {
    success,
    message,
    data,
  }
}
